/**
 * Copyright (c) 2016-present GlossGenius. All rights reserved.
 */

import React from 'react';

import { ClassicButton } from 'themes/classic/components/ClassicButton/ClassicButton';

import { useHomePage } from 'hooks/page/home/useHomePage';

import s from './ClassicHome.module.css';

const ClassicHome: React.FC = () => {
  const { bookNowLinkUrl } = useHomePage();

  return (
    <main className={s.root}>
      <ClassicButton url={bookNowLinkUrl}>Book Now</ClassicButton>
    </main>
  );
};

export { ClassicHome };
